export default {
  your_order_is_complete: "Your order is complete",
  the_order_procedure_is_complete: "The order procedure is complete.",
  please_wait_for_a_while_until_the_product_arrives: "Please wait for a while until the product arrives.",
  check_purchase_history: "Check purchase history",
  return_to_artist_top: "Return to artist top"
}